import { Layout } from 'antd';
import React, { useEffect, useState } from 'react'
import MainHeader from '../Header/Header';
import Sidebar from '../Sidebar/Sidebar';
import { LoadingSpinner } from 'pepsico-ds';
import { TabsNavigation, Tab } from "pepsico-ds";
import { getUserClaims } from '../../utils/auth/unified-auth';
import { useAuth } from "../../utils/auth/useAuth";
import './Layout.scss'
import { Outlet, useNavigate } from "react-router-dom";
import { useLocation, Link } from 'react-router-dom';
import { useRef } from "react";


const { Content } = Layout;


function MainLayout({ Component }) {
    const [userInfo, setUserInfo] = useState({});
    const { authState } = useAuth();
    const [selectedTab, setSelectedTab] = useState(1)
    const navigate = useNavigate();
    const location = useLocation();
    const currentPath = location.pathname;
    const tabs = [
    { label: "Overview", path: "/overview" },
    // { label: "Market Intelligence Hub", path: "/overview/commodity" },
    { label: "Market Intelligence Hub", path: "/overview/mi" },
    { label: "News & Trends", path: "/overview/news" },
    { label: "Export-Import Trade Analytics", path: "/overview/trade-analytics" },
    ];

    const tabRefs = useRef([]);

    const currentTab = (() => {
        switch (true) {
          case currentPath.includes('/commodity'):
            return 1;
          case currentPath.includes('/news'):
            return 2;
          case currentPath.includes('/trade-analytics'):
            return 3;
          default:
            return 0;
        }
    })();

    useEffect(() => {
        async function getUserInfo() {
            const user = await getUserClaims()
            if (user) {
                setUserInfo(user);
            }
        }
        getUserInfo()
    }, []);
    /* istanbul ignore next */
    const formattedDate = new Date().toLocaleDateString("en-US", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
    });
    /* istanbul ignore next */
    const handleKeyDown = (e, index) => {
        let nextIndex = index;

        //  TAB navigation (override default)
        if (e.key === "Tab") {
            e.preventDefault();

            nextIndex = e.shiftKey
            ? (index - 1 + tabs.length) % tabs.length
            : (index + 1) % tabs.length;

            tabRefs.current[nextIndex]?.focus();
        }

        //  Arrow navigation
        if (e.key === "ArrowRight") {
            e.preventDefault();
            nextIndex = (index + 1) % tabs.length;
            tabRefs.current[nextIndex]?.focus();
        }

        if (e.key === "ArrowLeft") {
            e.preventDefault();
            nextIndex = (index - 1 + tabs.length) % tabs.length;
            tabRefs.current[nextIndex]?.focus();
        }

        //  Navigation keys
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            navigate(tabs[index].path);
        }
    };
   
    return (
        <>
            <Layout>
                {/* <MainHeader /> */}
                <div style={{ display: 'flex', background: "#D7E5F8", minHeight:"125vh" }}>
                    {/* <Sidebar /> */}
                    <div style={{ width: '100%' }}>
                    {
                        (!currentPath.includes('/news-detail')) && (authState?.isAuthenticated) && 
                        // <TabsNavigation
                        //     selectedIndex={currentTab}
                        //     style={{padding: '15px 30px 15px 100px', background: '#D7E5F8', width: "100%"}}
                        //     className="ph-overview-nav"
                        //     >
                        //     <Tab
                        //     label="Overview"
                        //     onClick={function Xs() {
                        //         navigate("/overview");
                        //     }}
                        //     />
                        //     <Tab
                        //     label="Commodity Prices & Forecasts"
                        //     onClick={function Xs() {
                        //         navigate("/overview/commodity");
                        //     }}
                        //     iconTrailing="fiber_new"
                        //     />
                            
                        //     <Tab
                        //     label="News & Trends"
                        //     onClick={function Xs() {
                        //         navigate("/overview/news");
                        //     }}
                        //     iconTrailing="fiber_new"
                        //     />
                        //     <Tab
                        //     label="Export-Import Trade Analytics"
                        //     onClick={function Xs() {
                        //         navigate("/overview/trade-analytics");
                        //     }}
                        //     iconTrailing="fiber_new"
                        //     />
                        // </TabsNavigation>
                        // <div className="sticky-overview-tabs">
                        // <div className="sticky-overview-tabs-inner">
                        //     {tabs.map((tab) => (
                        //     <div
                        //         key={tab.path}
                        //         className={`sticky-overview-tab-item ${location.pathname === tab.path ? "active" : ""}`}
                        //         onClick={() => navigate(tab.path)}
                        //     >
                        //         {tab.label}
                        //     </div>
                        //     ))}
                        // </div>

                        // <div className="sticky-overview-date-badge">
                        //     <span className='sticky-overview-date-badge-value'>{formattedDate}</span>
                        // </div>
                        // </div>

                      <div className="sticky-overview-tabs">
                        <div className="sticky-overview-tabs-inner">
                            {tabs.map((tab, index) => {
                                const isActive = tab.label == "Overview"? location.pathname === tab.path : location.pathname.includes(tab.path) // location.pathname === tab.path;
                                return (
                                    <div
                                    key={tab.path}
                                    ref={(el) => (tabRefs.current[index] = el)}
                                    tabIndex={0}  //  all tabs focusable
                                    className={`sticky-overview-tab-item ${isActive ? "active" : ""}`}
                                    onClick={() => navigate(tab.path)}
                                    onKeyDown={(e) => handleKeyDown(e, index)}
                                    >
                                    {tab.label}
                                    </div>
                                );
                            })}
                        </div>

                        <div className="sticky-overview-date-badge">
                            <span className="sticky-overview-date-badge-value">
                            {formattedDate}
                            </span>
                        </div>
                      </div>
                    }
					{/* background: #F3F7FD */}
                    <Content style={{ padding: '0 30px 30px 100px', background: '#D7E5F8' }}>
                        {userInfo && Object.keys(userInfo).length === 0 ?
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: 'calc(100vh - 64px)' }}>
                                <LoadingSpinner
                                    size={{
                                        height: '80px',
                                        width: '80px'
                                    }}
                                />
                            </div>
                            : 
                                // <Component />
                                <Outlet/>
                            }
                    </Content>
                    </div>
                </div>
            </Layout>
        </>
    )
}

export default MainLayout